import { lt } from '@mews/framework';
import { Button, Dialog } from '@optimus-web/core';

export const RoutingRuleFormLeaveDialog = ({
    active,
    onClose,
    navigateToRoutingRulesTable,
}: {
    active: boolean;
    onClose: () => void;
    navigateToRoutingRulesTable: () => void;
}) => (
    <Dialog
        active={active}
        title={lt('RoutingRulesFormLeaveDialogTitle')}
        onClose={onClose}
        footer={{
            primary: (
                <Button variant="destructive" onClick={navigateToRoutingRulesTable} type="submit">
                    {lt('RoutingRulesFormLeaveDialogLeaveButton')}
                </Button>
            ),
            secondary: (
                <Button variant="tertiary" onClick={onClose} type="submit">
                    {lt('RoutingRulesFormLeaveDialogKeepEditingButton')}
                </Button>
            ),
        }}
    >
        {lt('RoutingRulesFormLeaveDialogDescription')}
    </Dialog>
);
